// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trackInvite_root__3OMD8 {\n  width: auto;\n  height: auto;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.trackInvite_select__35qGm {\n  margin-bottom: 20px; }\n\n.trackInvite_text__2GPYw {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: #464646; }\n", ""]);
// Exports
exports.locals = {
	"root": "trackInvite_root__3OMD8",
	"select": "trackInvite_select__35qGm",
	"text": "trackInvite_text__2GPYw"
};
module.exports = exports;
